import PropTypes from 'prop-types'

const permissionsType = PropTypes.oneOfType([
  PropTypes.array.isRequired,
  PropTypes.string.isRequired,
])

export default permissionsType
